/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FilterPendingUsersDto } from '../../models/filter-pending-users-dto';
import { ResponsePendingUserDto } from '../../models/response-pending-user-dto';

export interface PendingUsersControllerFilter$Params {
      body: FilterPendingUsersDto
}

export function pendingUsersControllerFilter(http: HttpClient, rootUrl: string, params: PendingUsersControllerFilter$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponsePendingUserDto>>> {
  const rb = new RequestBuilder(rootUrl, pendingUsersControllerFilter.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ResponsePendingUserDto>>;
    })
  );
}

pendingUsersControllerFilter.PATH = '/thalea-cognito-presignup/pending-users/filter';
